import { io } from "socket.io-client";

const socket = io(null, {
    reconnectionDelayMax: 3000,
    reconnection: true,
    reconnectionAttempts: Number.MAX_VALUE,
    timeout: 7000
});

export default socket;